import { render, staticRenderFns } from "./NewsEditForm.vue?vue&type=template&id=70097124&"
import script from "./NewsEditForm.vue?vue&type=script&lang=js&"
export * from "./NewsEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports